import dayjs from 'dayjs'

export const hasBorder = (date: dayjs.Dayjs) => {
  const daysWithoutBorders = [0, 5, 6]
  return !daysWithoutBorders.includes(date.get('day'))
}

export const isWeekday = (dateString: string) => {
  let date = dayjs(dateString)
  const weekends = [0, 6]
  return !weekends.includes(date.get('day'))
}
